import { useState } from "react";
import styled from "styled-components";
import { useContentContext } from "../../contexts/ContentContext";
import { useOutsideClick } from "../../utils/hooks/useOutsideClick";
import CustomIcon from "../Global/Icons/CustomIcon";

export const StyledSidebar = styled.div`
    width: 15em;
    background-color: black;
    position: relative;

ul{
    height: auto;
    padding: 0;
    width: 100%;
}

li{
    width: 100%;
    margin-bottom: 20%;
    list-style-type: none;
    display: flex;
    flex-direction: row;
    color: #A7A8AA;
    padding-left: 2em;
    align-items: center;
    font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    cursor: pointer;

    :hover{
        color: white;
    }

    #active{
        color:yellow;
    }

}`;

const ClosedStyledSideBar = styled.div`
    width: 3em;
    background-color: black;
    position: relative;
`;

const Pin = styled.div`
    z-index: 2;
    position: absolute;
    right: 2px;
    top: 6px;
`;

export const Sidebar = (props) => {
    const [isOpen, setIsOpen] = useState(true);
    const [activeId, setActiveId] = useState(0);
    /* const {changeGroup, currentSideBar} = useContentContext(); */
    const [isPinned, setIsPinned] = useState(true);

    const handleClickOutside = () => {
        setIsOpen(false);
    };

    const changeGroup = (value) => {
        props.changeSelectedMenu(value)
    }

    const ref = useOutsideClick(handleClickOutside);
    
    if(isOpen){
        return(
            <StyledSidebar ref={!isPinned ? ref : null}>
                <Pin onClick={() => setIsPinned(!isPinned)}>
                    <CustomIcon icon={'Pin_md'} fill={isPinned ? '#C4D600': '#63666a'}/>
                </Pin>
                <ul>
                    {props.sidebarMenus.map((val, key) => {
                        return(
                            <li
                            key={key} 
                            className = {activeId === key ? "sideBarListActive" : ""}
                            onClick={() => {setActiveId(key); changeGroup(val.group)}}>
                                <div>
                                    {val.title}
                                </div>
                            </li>
                        )
                    })}
                </ul>
                <div style={{color: '#C4D600', textAlign: 'center', position: 'absolute', bottom: '20px', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <p style={{marginRight: '10px'}}>Service Catalog</p>
                    <CustomIcon icon={'Layers_sm'} fill='#C4D600'/>
                </div>
            </StyledSidebar>
        )
    } else {
        return(
            <ClosedStyledSideBar>
                <div style={{margin: '10px', cursor: 'pointer'}} onClick={() => setIsOpen(true)}>
                    <CustomIcon icon={'Menu_xl'} fill='#C4D600'/>
                </div>
            </ClosedStyledSideBar>
        )
    }
    
}